<template>
  <section>
   

    <el-form inline>
      <el-form-item label="仓库编码">
        <el-input
          v-model="filters.keyword"
          placeholder="请输入仓库编码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-select v-model="filters.enabled" multiple="">
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库名称">
        <el-select v-model="filters.wareid" multiple="" filterable>
          <el-option
            v-for="item in WareHouse"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
     <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 查询报表 -->
    <el-table-bar :fixed="true" :bottom="35">  
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        highlight-current-row
      
        v-loading="listLoading"
        @selection-change="selsChange"
          ref="multipleTable"
          @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="warehouseCode"
          label="仓库编码"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="warehouseName"
          label="仓库名称"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="warehouseType"
          label="仓库类型"
          width="120"
          sortable
        >
          <template slot-scope="scope">{{
            scope.row.warehouseType == 10 ? "第三方" : "自有"
          }}</template>
        </el-table-column>

        <el-table-column prop="countryshow" label="国家" width="120" sortable>
        </el-table-column>
        <el-table-column prop="provinceshow" label="省份" width="120" sortable>
        </el-table-column>
        <el-table-column prop="cityshow" label="城市" width="120" sortable>
        </el-table-column>
      
        <el-table-column prop="address" label="地址" width="150" sortable>
        </el-table-column>
        <el-table-column prop="contacter" label="联系人" width="120" sortable>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="120" sortable>
        </el-table-column>
        <el-table-column prop="acreage" label="总面积（m²）" width="140" sortable>
        </el-table-column>
        <el-table-column
          prop="layerHeight"
          label="层高（m）"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="storageCapacity"
          label="总体积（m³）"
          width="140"
          sortable
        >
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150" sortable>
        </el-table-column>
        <el-table-column prop="status" label="是否启用" width="120" sortable>
          <template slot-scope="scope">{{
            scope.row.status ? "禁用" : "启用"
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="getbusinessLoglist(4, scope.row.warehouseId)"
              type="text"
              size="small"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" style="float:right;"
      >
      </el-pagination>
    </div>

    <!-- 新增模块 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addRuleForm"
         auto-complete="off"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="仓库编码"
              prop="WarehouseCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.WarehouseCode"
                auto-complete="off"
                placeholder="请输入仓库编码"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              prop="WarehouseName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.WarehouseName"
                auto-complete="off"
                placeholder="请输入仓库名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="仓库类型"
              class="labelcall"
              label-width="120px"
              prop="WarehouseType"
            >
              <el-select v-model="addForm.WarehouseType" style="width: 100%">
                <el-option label="第三方" value="10"></el-option>
                <el-option label="自有" value="20"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select v-model="addForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="国家"
              class="labelcall"
              label-width="120px"
              prop="Country"
            >
              <el-select
                v-model="addForm.Country"
                style="width: 100%"
                filterable
                placeholder="请选择"
                @change="provinces"
              >
                <el-option
                  v-for="item in countryList"
                  :label="item.name"
                  :value="item.code"
                  :key="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="省/市"
              prop="region"
              class="labelcall"
              label-width="120px"
            >
              <el-cascader
                style="width: 100%"
                placeholder="请选择"
                v-model="addForm.region"
                :options="options"
                filterable
                :key="isResouceShow"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="联系地址"
              prop="Address"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Address"
                auto-complete="off"
                placeholder="请输入地址"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人"
              prop="Contacter"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Contacter"
                auto-complete="off"
                placeholder="请输入联系人"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话"
              prop="Phone"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Phone"
                auto-complete="off"
                placeholder="请输入联系电话"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="总面积（m²）"
              prop="Acreage"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Acreage"
                auto-complete="off"
                placeholder="请输入总面积"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="层高"
              prop="LayerHeight"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.LayerHeight"
                auto-complete="off"
                placeholder="请输入层高"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="总体积（m³）"
              prop="StorageCapacity"
              class="labelcall"
              label-width="120px"
              maxlength="10"
            >
              <el-input
                v-model="addForm.StorageCapacity"
                auto-complete="off"
                placeholder="请输入总体积"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="备注"
              prop="Remark"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Remark"
                auto-complete="off"
                type="textarea"
                autosize
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 修改模块 -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editRuleForm"
       
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="仓库编码"
              prop="WarehouseCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.WarehouseCode"
                auto-complete="off"
                placeholder="请输入仓库编码"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              prop="WarehouseName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.WarehouseName"
                auto-complete="off"
                placeholder="请输入仓库名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="仓库类型"
              class="labelcall"
              label-width="120px"
              prop="WarehouseType"
            >
              <el-select
                v-model="editForm.WarehouseType"
                :disabled="isVisible"
                style="width: 100%"
              >
                <el-option label="第三方" value="10"></el-option>
                <el-option label="自有" value="20"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select
                v-model="editForm.Status"
                style="width: 100%"
                placeholder="请选择是否启用"
              >
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="国家"
              class="labelcall"
              label-width="120px"
              prop="Country"
            >
              <el-select
                v-model="editForm.Country"
                style="width: 100%"
                placeholder="请选择国家"
                @change="provinces"
                filterable
              >
                <el-option
                  v-for="item in countryList"
                  :label="item.name"
                  :value="item.code"
                  :key="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="省/市"
              prop="region"
              class="labelcall"
              label-width="120px"
            >
              <el-cascader
                style="width: 100%"
                placeholder="请选择省/市"
                v-model="editForm.region"
                :options="options"
                filterable
               :key="isResouceShow"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="联系地址"
              prop="Address"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.Address"
                auto-complete="off"
                placeholder="请输入联系地址"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人"
              prop="Contacter"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.Contacter"
                auto-complete="off"
                placeholder="请输入联系人"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话"
              prop="Phone"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.Phone"
                auto-complete="off"
                placeholder="请输入联系电话"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="总面积（m²）"
              prop="Acreage"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.Acreage"
                auto-complete="off"
                placeholder="请输入总面积"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="层高"
              prop="LayerHeight"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.LayerHeight"
                auto-complete="off"
                placeholder="请输入层高"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="总体积（m³）"
              prop="StorageCapacity"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.StorageCapacity"
                auto-complete="off"
                placeholder="请输入总体积"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="备注"
              prop="Remark"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.Remark"
                auto-complete="off"
                type="textarea"
                autosize
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
           <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onEditSubmit" :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 修改日志 -->
    <el-dialog
      :visible.sync="logFormVisible"
      v-model="logFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-table
        :data="logtableData"
        height="500"
        border
        style="width: 100%"
        v-loading="loglistLoading"
      >
        <el-table-column prop="createBy" label="操作人" width="120" sortable>
        </el-table-column>
        <el-table-column prop="ip" label="操作人IP地址" width="140" sortable>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="操作时间"
          width="180"
          sortable
          :formatter="formatdatetime"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="操作内容"
          min-width="300"
          sortable
        >
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="loghandleSizeChange"
          @current-change="loghandleCurrentChange"
          :current-page="logpage"
          :page-sizes="[10, 20, 50,100]"
          :page-size="logpageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logtotal" style="float:right;"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </section>
</template>
<style>
</style>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
import {
  addWarehouse,
  getWarehouseList,
  editWarehouse,
  exportWarehouse,
  editWarehouseStatus,
  getWarehousebase,
  getWarehouseQueryById,
  getbusinessLog,
  getCountryList,
  getStateCityAreaTree,
} from "../../api/api";
export default {
  components: { Toolbar },
  data() {
    var valinum = (rule, value, callback) => {
      if (parseFloat(value).toFixed(2) > 9999999.99) {
        console.log(parseFloat(value));
        callback(new Error("最大值为9999999.99"));
      } else {
        callback();
      }
    };

    return {
      options: [],
      isResouceShow: 0, // 绑定key值
      countryList: [],
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 50,
      tableData: [],

      filters: {
        keyword: "",
        enabled: "",
        wareid: "",
      },
      WareHouse: [],
      buttonList: {},
      addFormVisible: false,
      addLoading: false,
      addForm: {
        WarehouseCode: "",
        WarehouseName: "",
        Country: "",
        Province: "",
        City: "",

        Address: "",
        Status: "1",
        Contacter: "",
        Phone: "",
        Acreage: "",
        LayerHeight: "",
        StorageCapacity: "",
        Remark: "",
        region: [],
        WarehouseType: "",
      },

      addFormRules: {
        WarehouseCode: [
          {
            required: true,

            message: "请输入仓库编码",
            trigger: "blur",
          },
          {
            message: "仓库编码格式不正确,正确格式为字母+数字",
            trigger: "blur",
            pattern: /^((([a-z]|[A-Z])+[0-9]+)|(([A-Z]|[a-z])+[0-9]+))*$/,
          },
        ],
        WarehouseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
        ],
        Country: [{ required: true, message: "请选择国家", trigger: "change" }],
        region: [{ required: true, message: "请选择省市", trigger: "blur" }],

        Address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        Contacter: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^[0-9]+\d$/,
            message: "请输入正确的联系电话",
            trigger: "blur",
          },
        ],
        Acreage: [
          {
            required: true,
            message: "请输入正确的总面积",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            //message: "请正确的总面积",
            trigger: "blur",
            validator: valinum,
          },
        ],
        LayerHeight: [
          {
            required: true,
            message: "请输入正确的层高",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            trigger: "blur",
            validator: valinum,
          },
        ],
        StorageCapacity: [
          {
            required: true,
            message: "请输入正确的总体积",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            trigger: "blur",
            validator: valinum,
          },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
        WarehouseType: [
          { required: true, message: "请选择仓库类型", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editLoading: false,
      editForm: {
        WarehouseId: 0,
        WarehouseCode: "",
        WarehouseName: "",
        Country: "",
        Province: "",
        City: "",
        Address: "",
        Status: "",
        Contacter: "",
        Phone: "",
        Acreage: "",
        LayerHeight: "",
        StorageCapacity: "",
        Remark: "",
        region: [],
        WarehouseType: "",
        BYWarehouseCode:"",
        OperateType:0,
      },
      editFormRules: {
        WarehouseCode: [
          {
            required: true,

            message: "请输入仓库编码",
            trigger: "blur",
          },
           
        ],
        WarehouseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
        ],

        Country: [{ required: true, message: "请选择国家", trigger: "change" }],
        region: [{ required: true, message: "请选择省市", trigger: "blur" }],

        Address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        Contacter: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^[0-9]+\d$/,
            message: "请输入正确的联系电话",
            trigger: "blur",
          },
        ],
        Acreage: [
          {
            required: true,
            message: "请输入正确的总面积",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            trigger: "blur",
            validator: valinum,
          },
        ],
        LayerHeight: [
          {
            required: true,
            message: "请输入正确的层高",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            trigger: "blur",
            validator: valinum,
          },
        ],
        StorageCapacity: [
          {
            required: true,
            message: "请输入正确的总体积",
            trigger: "blur",
            pattern: /^[+]?[0-9]+(\.[0-9]{1,2})?$/,
          },
          {
            validator: valinum,
            trigger: "blur",
          },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
        WarehouseType: [
          { required: true, message: "请选择仓库类型", trigger: "change" },
        ],
      },
      currentRow: null,
      sels: [],
      validation: true,
      isVisible: false, //是否允许修改仓库类型
      logFormVisible: false,
      logtableData: [],
      loglistLoading: false,
      logtotal: 0,
      logpage: 1,
      logpageSize: 50,
      logbusinessType: 0,
      newfilters:{},
      logbusinessCode: 0,
    };
  },
  methods: {
    //加载权限按钮
     
   callFunction(item) {
      if (item.name === "查询") {
         this.page=1;
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) ;
          this.getWarelist.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //弹出新增框
    onSubmitadd() {
      this.addFormVisible = true;
      this.addLoading = false;
    },
    //弹出修改框
    onSubmitedit() {
      let row = {};
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length === 1) {
        row = this.sels[0];
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      this.editLoading = false;
      if (!row || row.warehouseId == 0) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }

      let pata = {
        id: row.warehouseId,
      };
     
      getWarehouseQueryById(pata).then((res) => {
        if (res.data.success) {
          let editdata = res.data.response;
          this.provinces(editdata.country)
          this.editForm.warehouseId = editdata.warehouseId;
          this.editForm.WarehouseCode = editdata.warehouseCode;
          this.editForm.WarehouseName = editdata.warehouseName;
          this.editForm.Country = editdata.country;
          this.editForm.Contacter = editdata.contacter;
          this.editForm.Address = editdata.address;
          this.editForm.Status = editdata.status + "";
          this.editForm.Contacter = editdata.contacter;
          this.editForm.Phone = editdata.phone;
          this.editForm.Acreage = editdata.acreage;
          this.editForm.LayerHeight = editdata.layerHeight;
          this.editForm.StorageCapacity = editdata.storageCapacity;
          this.editForm.Remark = editdata.remark;
          this.editForm.BYWarehouseCode=editdata.byWarehouseCode;
          this.editForm.OperateType=editdata.operateType;
          this.editForm.WarehouseType = editdata.warehouseType + "";
          this.editForm.region = [];
          this.editForm.region.push(editdata.province);
          this.editForm.region.push(editdata.city);
          this.isVisible = editdata.isVisible;
          this.editFormVisible = true;
        } else {
          this.$message({
            message:res.data.msg,
            type: "error",
          });
        }
      });
    },

    //隐藏新增修改框
    onSubmicancel() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
  //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    //获取每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWarelist();
    },
    //获取页码
    handleCurrentChange(val) {
      this.page = val;
      this.getWarelist();
    },
    //多选
    selsChange(sels) {
      this.sels = sels;
      console.log(sels, 1111);
    },
    //新增
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      console.log(para);

      if (para.region.length == 0) {
        this.$message({
          message: "请选择省/市",
          type: "error",
        });
        return;
      }
      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
        
            para.Province = para.region[0];
            para.City = para.region[1];
            this.addLoading = true;
            addWarehouse(para).then((res) => {
              this.addLoading = false;
              console.log(res);
              if (res.data.success) {
                this.addFormVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.getWarelist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },
    //修改
    onEditSubmit() {
     
      let para = Object.assign({}, this.editForm);
      if (para.region.length == 0) {
        this.$message({
          message: "请选择省/市",
          type: "error",
        });
        return;
      }
      let _this = this;
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
           
            para.Province = para.region[0];
            para.City = para.region[1];
            console.log(para, user);
            this.editLoading = true;
            editWarehouse(para).then((res) => {
              this.editLoading = false;
              console.log(res);
              if (res.data.success) {
                this.editFormVisible = false;
                this.$refs["editRuleForm"].resetFields();
                this.getWarelist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },

    //查询
    getWarelist() {
       
      let pata = {
        page: this.page,
        pageSize: this.pageSize,
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
      };
      this.listLoading = true;
      getWarehouseList(pata).then((res) => {
        console.log(res);
        this.tableData = res.data.response.pageData;
        this.total = res.data.response.total;
        this.listLoading = false;
      });
    },
    //导出
    handleExport() {
      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.warehouseId + ",";
      });
      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
        warehouseid: warelist.slice(0, warelist.length - 1),
      };
      console.log(pata);
        const loading = this.$loading({
          lock: true,
          text: '导出，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
      exportWarehouse(pata);
      loading.close();
    },
    //点击启用按钮
    handleEnable() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.length == 1) {
        if (row[0].status == 0) {
          this.validation = false;
          this.$message({
            message: "当前数据为启用状态，无需启用！",
            type: "error",
          });
          return;
        }
      }
      row.forEach((item) => {
        if (item.status == 0) {
          this.validation = false;
          this.$message({
            message: "请选择禁用的数据启用！",
            type: "error",
          });

          return false;
        }
      });

      let para = Object.assign([], row);

      console.log(para);
      if (this.validation) {
        this.$confirm("确认启用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 0;
          }
          editWarehouseStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getWarelist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },
    //点击禁用按钮
    handleStop() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择启用的数据禁用！",
          type: "error",
        });

        return false;
      }
      if (row.length == 1) {
        if (row[0].status == 1) {
          this.validation = false;
          this.$message({
            message: "当前数据为禁用状态，无需禁用！！",
            type: "error",
          });
          return;
        }
      }
      row.forEach((item) => {
        if (item.status == 1) {
          this.validation = false;
          this.$message({
            message: "请选择启用的数据禁用！",
            type: "error",
          });
          return false;
        }
      });
      if (this.validation) {
        let para = Object.assign([], row);
        this.$confirm("确认禁用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 1;
          }
          editWarehouseStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getWarelist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },

    //加载基础资料
    getWarebaselist() {
      // getWarehousebase("").then((res) => {
      //   console.log(res);
      //   this.WareHouse = res.data.response.wareHouse;
      // });
      let user = JSON.parse(window.localStorage.user);
      this.WareHouse = user.warehouseList;
      getCountryList("").then((res) => {
        console.log(res);
        this.countryList = res.data.response;
        this.addForm.Country="CN";
        this.provinces(this.addForm.Country)
      });
    },

    //获取每页条数
    loghandleSizeChange(val) {
      this.logpageSize = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //获取页码
    loghandleCurrentChange(val) {
      this.logpage = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //查询
    getbusinessLoglist(businessType, businessCode) {
      this.logbusinessType = businessType;
      this.businessCode = businessCode;
      this.logFormVisible = true;
      let pata = {
        businessType: this.logbusinessType,
        businessCode: this.businessCode,
        page: this.logpage,
        pageSize: this.logpageSize,
      };
      this.loglistLoading = true;
      getbusinessLog(pata).then((res) => {
        console.log(res);
        this.logtableData = res.data.response.pageData;
        this.logtotal = res.data.response.total;
        this.loglistLoading = false;
      });
    },
    formatdatetime: function (row) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.createTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
    provinces(value) {
      let pata = {
        country: value,
      };
      this.options = [];
      ++this.isResouceShow;
      getStateCityAreaTree(pata).then((res) => {
        this.options = res.data.response;
        console.log(this.options);
      });
    },
  },
  mounted() {
   
    this.getWarebaselist();
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    // console.log(111);
  },
  watch: {
    options: {
      handler(v1, v2) {
        ++this.isResouceShow;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>